<template>
  <div class="app-page box-card">
    <div class="box-card-content">
      <div class="reset-query query">
        <el-form :inline="true" :model="queryForm">

          <el-form-item label="转账类型">
            <template slot="label">
              <I18Lang id="my129" defaultText="转账类型" />
            </template>
            <el-select v-model="queryForm.transfer_type" :placeholder="$t('public17')">
              <el-option :label="$t('public18')" value=""></el-option>
              <el-option v-for="(item, key) in transferTypesText" :label="item" :value="key" :key="key"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="转账ID">
            <template slot="label">
              <I18Lang id="my133" defaultText="转账ID" />
            </template>
            <el-input :placeholder="$t('my134')" v-model="queryForm.transfer_account_id"></el-input>
          </el-form-item>

          <el-form-item label="Transfer Time">
            <el-date-picker v-model="queryDate" type="daterange" @change="dateChange" value-format="yyyy-MM-dd"
              range-separator="-" :start-placeholder="$t('public22')" :end-placeholder="$t('public23')"></el-date-picker>
          </el-form-item>

          <div class="btn kg-btn2" @click="queryQuery">
            <I18Lang id="my85" defaultText="查询" />
          </div>
          <div class="btn kg-refresh btn-query-refresh" @click="resetQuery"></div>

        </el-form>
        <div>
          <div class="btn kg-btn2" @click="importData">
            <I18Lang id="my137" defaultText="导出" />
          </div>
        </div>
      </div>

      <div class="reset-table table">
        <el-table :data="tableData.list" style="width: 100%">
          <el-table-column width="200" label="流水号" prop="stream_no">
            <template slot="header">
              <I18Lang id="my66" defaultText="流水号" />
            </template>
          </el-table-column>
          <el-table-column label="转账ID" prop="transfer_account_id">
            <template slot="header">
              <I18Lang id="my133" defaultText="转账ID" />
            </template>
          </el-table-column>
          <el-table-column label="转账金额($)" prop="amount">
            <template slot="header">
              <I18Lang id="my141" defaultText="转账金额($)" />
            </template>
          </el-table-column>

          <el-table-column label="操作后账户余额(MEQ)" prop="cash_balance">
            <template slot="header">
              <I18Lang id="recordAfterBalance" defaultText="操作后账户余额(MEQ)" />
            </template>
          </el-table-column>

          <el-table-column label="转账类型">
            <template slot="header">
              <I18Lang id="my129" defaultText="转账类型" />
            </template>
            <template slot-scope="scope">
              {{ transferTypesText[scope.row.transfer_type] }}
            </template>
          </el-table-column>

          <el-table-column label="转账时间" prop="create_time">
            <template slot="header">
              <I18Lang id="my154" defaultText="转账时间" />
            </template>
          </el-table-column>

        </el-table>
        <div class="page">
          <el-pagination background @current-change="pageChange" layout="prev, pager, next"
            :total="tableData.total"></el-pagination>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { fileDomain, formateObjToParamStr } from '@utils'
import cookie from '@utils/cookie'
import { mapState } from 'vuex'
import { auditStatusList } from '@utils/global'
export default {
  name: 'record',
  data () {
    return {
      fileDomain,
      transferObjs: {
        1: this.$t('my30'), // 代理
        2: this.$t('my128') // 用户
      },
      transferTypesText: {
        1: this.$t('transferrecord1'), // 收到他人转账
        2: this.$t('transferrecord2') // 给他人转账
      },
      queryDate: '',
      queryForm: {
        transfer_target: '',
        transfer_type: '',
        transfer_account_id: '',
        start_time: '',
        end_time: '',
        page: 1,
        size: 10
      },
      statusList: auditStatusList,
      tableData: {
        list: [],
        total: 0
      }
    }
  },
  computed: {
    ...mapState(['userInfo'])
  },
  created () {
    this.getRecord()
  },
  methods: {
    importData () {
      const params = {
        token: cookie.get('kg-client-token'),
        ...this.queryForm,
        is_export: 1
      }
      window.open(
        `/api/cash/transferRecords?${formateObjToParamStr(
          params
        )}`
      )
    },
    getRecord () {
      this.$http
        .post('/api/cash/transferRecords', this.queryForm)
        .then((result) => {
          console.log('result', result)
          this.tableData = result
        })
    },
    queryQuery () {
      this.pageChange(1)
    },
    resetQuery () {
      Object.keys(this.queryForm).map(item => {
        if (!['page', 'size', 'is_agent'].includes(item)) {
          this.queryForm[item] = ''
        }
      })
      this.queryDate = ''
      this.pageChange(1)
    },
    dateChange (val) {
      this.queryForm.start_time = val ? val[0] : ''
      this.queryForm.end_time = val ? val[1] : ''
    },
    pageChange (page) {
      this.queryForm.page = page
      this.getRecord()
    }
  }
}
</script>
<style scoped lang="scss"></style>
